import { CalendarEntryEntityType } from '../../types/event';

export interface CalendarEntry {
  id: string;
  start: string;
  end: string;
  isAllDay: boolean;
  title?: string;
  entityType?: CalendarEntryEntityType;
}

export const calendarEntryProps: (keyof CalendarEntry)[] = ['id', 'start', 'end', 'isAllDay', 'title'];
